var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", { staticClass: "d-block" }, [
        _vm._v("Zusätzliche Dateianhänge"),
      ]),
      _vm._v(" "),
      _c(
        "csp-base-file-upload",
        {
          ref: "fileUpload",
          staticClass: "multi-file-upload",
          attrs: {
            "auto-process-queue": true,
            "file-input-name": "fileUpload",
            "multiple-upload": true,
            title: _vm.$t("record document upload"),
            "upload-error-message": _vm.$t("record document upload error"),
            "upload-url": _vm.uploadUrl,
          },
          on: {
            "after-files-added": _vm.handleAfterFilesAdded,
            "before-upload": _vm.handleBeforeUpload,
            "file-added": _vm.handleFileAdded,
            "file-upload-complete": _vm.handleFileUploadComplete,
            "file-upload-progress": _vm.handleFileUpdate,
            "total-upload-progress": _vm.handleTotalUploadProgress,
            "upload-complete": _vm.handleUploadComplete,
            "upload-disabled": _vm.handleUploadDisabled,
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.commonAttachments.length > 0
        ? _c("b-table", {
            ref: "commonAttachments",
            attrs: {
              fields: _vm.attachmentFields,
              items: _vm.commonAttachments,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(selected)",
                  fn: function (rowData) {
                    return [
                      _c("b-form-checkbox", {
                        attrs: {
                          checked: rowData.item.checked,
                          value: rowData.item.name,
                        },
                        on: {
                          change: (checked) =>
                            _vm.handleCheckboxChange(rowData, checked),
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1381375014
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }